var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Tag"},[_c('div',{staticClass:"Tag_left"},[_c('div',{staticClass:"Tag_left_icon"}),_c('div',{staticClass:"Tag_left_text"},[_vm._v(_vm._s(_vm.name))])]),_c('div',{staticClass:"Tag_right"},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }